import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=2971217b"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports